import { Anchor, Group, Text } from '@mantine/core';

interface FooterProps {
  innerRef?: React.LegacyRef<HTMLElement>;
}

export default function Footer({ innerRef }: FooterProps) {
  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <footer ref={innerRef}>
      <Group px="md" pt="xl" pb="sm" justify="end">
        <Text size="xs">
          Developed by{' '}
          <Anchor
            size="xs"
            href="https://www.miroirstudio.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Miroir Studio
          </Anchor>
        </Text>
      </Group>
    </footer>
  );
}
